module.exports = __webpack_public_path__ + "img/crying-duck.2f6e84f5.gif";